import styled from 'styled-components';

export const CategoryWrapper = styled.div`
  position: relative;
  margin-top: 30px;
  overflow: hidden;
  ${({ scrollEnd }) =>
    !scrollEnd &&
    `&::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 100%;
    background: linear-gradient(to left, white 40%, transparent);
  }`}

  .scrollContainer {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    gap: 8px;
    padding: 5px;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  button {
    line-height: 1.6rem;
    padding: 9px 18px;
    margin: 0 8px 16px 0;

    font-size: 1.4rem;
    text-align: center;
    vertical-align: middle;

    color: #009ff9;
    background: '#fff';
    border: 1px solid #009ff9;
    border-radius: 50px;

    &:last-child {
      margin-right: 20px;
    }

    @media screen and (max-width: 320px) {
      padding: 6px 12px;
      font-size: 1.2rem;
      margin: 0 7px 8px 0;
    }
  }

  .isactive {
    color: #fff;
    background: #009ff9;
  }
`;
